const ProfileAddress = {
  "options": {
    "data": {
      "images": [
        {
          "to": "",
          "src": ""
        }
      ]
    },
    "customization": {},
    "widgets": {}
  },
  "variants": [
    {
      "id": "ProfileAddress_1",
      "name": "ProfileAddress_1",
      "type": "ProfileAddress",
      "data": {
        "images": [
          {
            "to": "",
            "src": ""
          }
        ]
      },
      "customization": {},
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Search+1%402x.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    }
  ]
}

 export default ProfileAddress